import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_NAME, DEFAULT_LOCALE } from './constants';
import { Languages, LanguageState } from '../../domains/locales';
import { Language } from '../Questionnaires/questionnaires';

export const slice = createSlice({
  name: SLICE_NAME,

  initialState: {
    locale: DEFAULT_LOCALE,
    listLanguages: [],
  } as LanguageState,

  reducers: {
    changeLocale: (state, action: PayloadAction<Languages>) => {
      state.locale = action.payload;
    },
    setListLanguages: (state, action: PayloadAction<Language[]>) => {
      state.listLanguages = action.payload;
    },
  },
});

export const { changeLocale, setListLanguages } = slice.actions;

export default slice.reducer;
